class TasacionesTooltips {
    constructor(config = {}) {
        this.config = Object.assign({
            selector: '[data-tasacion-tooltip-id]',
            offset: 8,
            closeOnOutsideClick: true,
            closeOnEscape: true,
            openIconText: '<span class="tasaciones-tooltip-icon">×</span>'
        }, config);

        this.state = {
            open: null // { icon, tooltip, originalParent, originalNextSibling, originalIconHTML }
        };

        this.bound = {
            onDocumentClick: (e) => this.handleDocumentClick(e),
            onKeyDown: (e) => this.handleKeyDown(e),
            onScrollOrResize: () => this.reposition()
        };
    }

    init() {
        // Delegación sencilla: capturamos clics en documento y detectamos el icono con closest
        document.addEventListener('click', this.bound.onDocumentClick, false);
    }

    destroy() {
        document.removeEventListener('click', this.bound.onDocumentClick, true);
        this.close();
    }

    handleDocumentClick(event) {
        const icon = event.target.closest(this.config.selector);
        const open = this.state.open;

        if (icon) {
            event.preventDefault();
            if (open && open.icon === icon) {
                this.close();
            } else {
                this.open(icon);
            }
            return;
        }

        if (this.config.closeOnOutsideClick && open) {
            const clickInsideTooltip = open.tooltip.contains(event.target);
            const clickOnIcon = open.icon.contains(event.target);
            if (!clickInsideTooltip && !clickOnIcon) {
                this.close();
            }
        }
    }

    handleKeyDown(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            this.close();
        }
    }

    findIconFrom(target) {
        if (!target) return null;
        const matches = (el) => el.matches && el.matches(this.config.selector);
        let el = target;
        while (el && el !== document && el !== document.documentElement) {
            if (matches(el)) return el;
            el = el.parentElement;
        }
        return null;
    }

    getTooltipForIcon(icon) {
        const id = icon.getAttribute('data-tasacion-tooltip-id') || icon.getAttribute('aria-controls');
        if (!id) return null;
        return document.getElementById(id);
    }

    open(icon) {
        const tooltip = this.getTooltipForIcon(icon);
        if (!tooltip) return;

        // Cerrar otro si está abierto
        if (this.state.open) this.close();

        // Guardar estado original
        const originalParent = tooltip.parentElement;
        const originalNextSibling = tooltip.nextSibling;
        const originalIconHTML = icon.innerHTML;
        const hadHiddenClass = tooltip.classList.contains('tasaciones-hidden');

        // Mostrar tooltip: quitar 'tasaciones-hidden' si existe y posicionarlo flotante
        if (hadHiddenClass) tooltip.classList.remove('tasaciones-hidden');
        tooltip.style.position = 'fixed';
        tooltip.style.left = '-9999px';
        tooltip.style.top = '-9999px';
        tooltip.style.zIndex = '9999';
        document.body.appendChild(tooltip);

        // Marcar icono abierto
        icon.classList.add('tasaciones-inline-block');
        icon.setAttribute('aria-expanded', 'true');
        icon.dataset.tooltipOriginalHtml = originalIconHTML;
        icon.innerHTML = this.config.openIconText;

        // Guardar estado abierto
        this.state.open = {
            icon,
            tooltip,
            originalParent,
            originalNextSibling,
            originalIconHTML,
            hadHiddenClass
        };

        // Listeners solo mientras esté abierto
        if (this.config.closeOnEscape) {
            document.addEventListener('keydown', this.bound.onKeyDown, true);
        }
        window.addEventListener('scroll', this.bound.onScrollOrResize, true);
        window.addEventListener('resize', this.bound.onScrollOrResize, true);

        // Posicionar
        this.reposition();
    }

    close() {
        const s = this.state.open;
        if (!s) return;

        // Restaurar icono
        s.icon.removeAttribute('aria-expanded');
        if (s.icon.dataset.tooltipOriginalHtml !== undefined) {
            s.icon.innerHTML = s.icon.dataset.tooltipOriginalHtml;
            delete s.icon.dataset.tooltipOriginalHtml;
        } else {
            s.icon.textContent = '';
        }

        // Restaurar tooltip
        if (s.hadHiddenClass) {
            s.tooltip.classList.add('tasaciones-hidden');
        }
        s.tooltip.style.left = '';
        s.tooltip.style.top = '';
        s.tooltip.style.position = '';
        s.tooltip.style.zIndex = '';

        if (s.originalParent) {
            if (s.originalNextSibling && s.originalNextSibling.parentNode === s.originalParent) {
                s.originalParent.insertBefore(s.tooltip, s.originalNextSibling);
            } else {
                s.originalParent.appendChild(s.tooltip);
            }
        }

        // Quitar listeners temporales
        document.removeEventListener('keydown', this.bound.onKeyDown, true);
        window.removeEventListener('scroll', this.bound.onScrollOrResize, true);
        window.removeEventListener('resize', this.bound.onScrollOrResize, true);

        this.state.open = null;
    }

    reposition() {
        const s = this.state.open;
        if (!s) return;
        const { icon, tooltip } = s;

        const iconRect = icon.getBoundingClientRect();

        // Medir tamaño real
        tooltip.style.left = '-9999px';
        tooltip.style.top = '-9999px';

        const tipRect = tooltip.getBoundingClientRect();
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        let left = iconRect.left + (iconRect.width - tipRect.width) / 2;
        left = Math.max(8, Math.min(left, vw - tipRect.width - 8));

        let top = iconRect.bottom + this.config.offset;
        if (top + tipRect.height > vh - 8) {
            top = iconRect.top - tipRect.height - this.config.offset;
            if (top < 8) {
                top = Math.max(8, Math.min(top, vh - tipRect.height - 8));
            }
        }

        tooltip.style.left = `${Math.round(left)}px`;
        tooltip.style.top = `${Math.round(top)}px`;
    }
}

window.TasacionesTooltips = TasacionesTooltips;